import { FC } from "react";
import { AuditoriasRouter } from "./AuditoriasRouter";

export const Auditorias: FC = () => {
    return (
        <>
            <AuditoriasRouter />
        </>
    )
}